import { Button } from "../ui/button";
import { X } from "lucide-react";

/**
 * Sticky top-of-tab bar that appears when at least one row is selected.
 * Pass `children` for the per-tab action buttons (Change role / Delete / …).
 */
export function BulkBar({ count, onClear, children, testId = "bulk-bar" }) {
  if (!count) return null;
  return (
    <div
      className="sticky top-2 z-30 flex flex-wrap items-center gap-3 rounded-xl border border-primary/40
                 bg-primary/5 backdrop-blur px-4 py-3 shadow-sm fade-up"
      data-testid={testId}
    >
      <div className="font-mono text-sm" data-testid={`${testId}-count`}>
        {count} selected
      </div>
      <div className="flex-1" />
      <div className="flex items-center flex-wrap gap-2">{children}</div>
      <Button
        size="sm"
        variant="ghost"
        onClick={onClear}
        data-testid={`${testId}-clear`}
        aria-label="Clear selection"
      >
        <X size={14} />
      </Button>
    </div>
  );
}

/**
 * Shadcn-free checkbox that uses the native input with tailwind styling so
 * it's accessible and keyboard-friendly. We pass `data-testid` through from
 * the caller.
 */
export function RowCheck({ checked, onChange, testId, label = "Select row" }) {
  return (
    <input
      type="checkbox"
      checked={!!checked}
      onChange={(e) => onChange(e.target.checked)}
      onClick={(e) => e.stopPropagation()}
      aria-label={label}
      data-testid={testId}
      className="h-4 w-4 rounded border-border accent-primary cursor-pointer"
    />
  );
}
